// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1gNQD","savePackageButton":"ClientWallet_savePackageButton__2jUCQ"};